import React, { useState } from 'react'
import { DocumentStatusOption } from '../constants'
import UpdateDocumentComment from '../../queries/UpdateDocumentComment'
import { useMutation } from '@apollo/react-hooks'
import { useSnackbar } from '../../contexts/SnackbarContext'
import Select, { SelectOption } from '../select'
import { getIsSelectEnabled, getSelectOptions, getShallowStatus } from './utils'
import SendNoteModal, { SendNoteModalVariant } from '../send-note-modal'
import { useDocumentsConfig } from '../../contexts/DocumentsConfigContext'
import useUpdateDocumentStatus from '../hooks/useUpdateDocumentStatus'

function Status({ document, resourceType }) {
  const { note, rid: documentId } = document
  const shallowStatus = getShallowStatus(document)

  const { updateStatus, loading } = useUpdateDocumentStatus()

  const { setErrorMessage } = useSnackbar()
  const [showRejectReasonModal, setShowRejectReasonModal] = useState(false)
  const {
    superUser,
    customerService,
    bankAdmin,
    bankProcessor,
    preventMarkAsNotRequired,
  } = useDocumentsConfig()

  const [updateCommentMutation] = useMutation(UpdateDocumentComment, {
    onError: () =>
      setErrorMessage('There was an error updating the document comment'),
  })

  const handleStatusChange = (newStatus) => {
    if (newStatus === DocumentStatusOption.rejected)
      return setShowRejectReasonModal(true)

    if (newStatus === DocumentStatusOption.approve_and_commit)
      updateCommentMutation({
        variables: {
          input: {
            documentId,
            comment: '',
          },
        },
      })

    updateStatus({ documentId, newStatus })
  }

  const handleRejection = () =>
    updateStatus({
      documentId,
      newStatus: DocumentStatusOption.rejected,
    })

  // weird arbitrary logic inherited from legacy document component
  const options = getSelectOptions({
    document,
    customerService,
    resourceType,
    preventMarkAsNotRequired,
  })

  const isSelectEnabled =
    options.length > 1 &&
    getIsSelectEnabled({
      document,
      superUser,
      bankAdmin,
      bankProcessor,
    })

  return (
    <>
      <Select
        value={loading ? 'loading' : shallowStatus}
        onChange={(e) => handleStatusChange(e.target.value)}
        disabled={!isSelectEnabled}
        width="80%"
      >
        {loading && <option value="loading">Loading...</option>}
        {options.map(({ option, label }) => (
          <SelectOption key={option} value={option}>
            {label}
          </SelectOption>
        ))}
      </Select>
      {showRejectReasonModal && (
        <SendNoteModal
          documentId={documentId}
          note={note}
          onClose={() => setShowRejectReasonModal(false)}
          onSuccess={handleRejection}
          variant={SendNoteModalVariant.REJECTION_REASON}
        />
      )}
    </>
  )
}

export default Status
